import { FC } from "react";
import { Col, Row, Input } from "antd";
import { LinkList, LinkListProps } from "../../components/link-list/link-list";
import {
  IMidia,
  SocialMidia,
} from "../../components/social-midia/social-midia";
import { Container } from "../../components/container/container";
import { PhoneFilled, MailFilled } from "@ant-design/icons";

import "./footer.css";

export interface FooterProps {
  lists: LinkListProps[];
  social: IMidia[];
  contact: string;
  ramal: string;
  email: string;
  address: string;
}

const { Search } = Input;

const onSearch = (value: string) =>
  (window.location.href = `/app/catalog/search/${value}`);

export const Footer: FC<FooterProps> = ({
  lists,
  social,
  contact,
  email,
  ramal,
}) => {
  return (
    <div>
      {/* <div className="rectangle-wrapper">
        <div className="rectangle-blue" />
        <div className="rectangle-yellow" />
        <div className="rectangle-red" />
        <div className="rectangle-green" />
      </div> */}
      <div className="xvia-footer">
        <Container className="xvia-footer__container">
          <a
            href={process.env.PORTAL_URL || "/"}
            aria-label="Ir para a página inicial do portal Pi Digital"
          >
            <img
              className={"xvia-footer__govpi__logo__hidden"}
              src={`${process.env.PUBLIC_URL}/images/svgs/logo_white_descaracterizada.svg`}
              alt="Governo do Estado do Piauí"
            />
          </a>

          <div>
            <Row justify="space-between">
              {lists?.map((list) => (
                <Col key={list.title} className="xvia-footer__card">
                  <LinkList title={list.title} linkList={list.linkList} />
                </Col>
              ))}
            </Row>
          </div>
        </Container>
        <div className="xvia-line-spacing-footer"></div>

        <Container className="xvia-footer__container">
          <div>
            <Row justify="space-between" gutter={[3, 34]} align="middle">
              <Col xs={24} sm={24} md={24} lg={3} xl={3} xxl={2}>
                <div>
                  <img
                    className="xvia-footer__logo"
                    src={`${process.env.PUBLIC_URL}/images/svgs/logo_white_descaracterizada.svg`}
                    alt="logomapa"
                  />
                </div>
              </Col>
              <Col xs={24} sm={24} md={12} lg={8} xl={6} xxl={6}>
                <div>
                  <PhoneFilled style={{ color: "white" }} />
                  <span className="xvia-link-sub-footer-text">{contact}</span>
                  <PhoneFilled style={{ color: "white" }} />
                  <span className="xvia-link-sub-footer-text">{ramal}</span>
                </div>
                <div>
                  <MailFilled style={{ color: "white" }} />
                  <span className="xvia-link-sub-footer-text">{email}</span>
                </div>
              </Col>
              <Col xs={0} sm={0} md={0} lg={6} xl={6} xxl={6} />
              <Col xs={12} sm={24} md={12} lg={6} xl={6} xxl={6}>
                {/* <SocialMidia midiasList={social} /> */}
              </Col>
            </Row>
          </div>
        </Container>
      </div>
    </div>
  );
};
